<template>
  <div class="simple-pie-chart">
    <apexchart v-if="ApexChartsComponent" :is="ApexChartsComponent" type="bar" height="200" :options="chartOptions"
               :series="series"/>
  </div>
</template>

<script lang="ts" setup>
import {defineComponent, ref, onMounted, watch} from 'vue';
import {dateRange, financialResponse} from "../../composables/getFinancial";


const series = ref([
  {
    name: 'Omzet',
    data: [financialResponse.value.financialData[0]?.totalRevenue??0, financialResponse.value.financialData[1]?.totalRevenue??0, financialResponse.value.financialData[2]?.totalRevenue??0]
  },
  {
    name: 'Kosten',
    data: [financialResponse.value.financialData[0]?.reportExpenses??0, financialResponse.value.financialData[1]?.reportExpenses??0, financialResponse.value.financialData[2]?.reportExpenses??0]
  },
  {
    name: 'Winst/Verlies',
    data: [financialResponse.value.financialData[0]?.profitReport??0, financialResponse.value.financialData[1]?.profitReport??0, financialResponse.value.financialData[2]?.profitReport??0]
  }
]);

const chartOptions = ref({
  chart: {
    type: 'bar',
    height: 200,
    events: {
      mounted: (chart: any) => {
        console.log('Chart mounted', chart);
        chart.windowResizeHandler();
      }
    }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      dataLabels: {
        position: 'top',
      },
    }
  },
  dataLabels: {
    enabled: false,
    offsetX: -18,
    style: {
      fontSize: '12px',
      colors: ['#fff']
    }
  },
  stroke: {
    show: true,
    width: 1,
    colors: ['#fff']
  },
  yaxis: {
    labels: {
      formatter: function (value: any) {
        return `€${value.toLocaleString()}`;
      }
    },
    categories: ['Revenue', 'Costs', 'Profit/Loss'],
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'left',
    markers: {
      shape: 'circle'
    }
  },

  labels:[new Date(dateRange.value).toLocaleString('en', { month: 'short' }),
    new Date(dateRange.value).setMonth(dateRange.value.getMonth() - 1).toLocaleString('en', { month: 'short' }),
    new Date(dateRange.value).setMonth(dateRange.value.getMonth() - 2).toLocaleString('en', { month: 'short' })],
  colors: ['#FFA5CB', '#E697FF', '#63ABFD']
});
watch(dateRange, (newValue) => {
  console.log("dateRange changed revenue chart");
  const range = new Date(newValue);
  console.log(newValue);
  chartOptions.value = {
    ...chartOptions.value,
    labels: [
      range.toLocaleString('en', {month: 'short'}),
      new Date(range.setMonth(range.getMonth() - 1)).toLocaleString('en', {month: 'short'}),
      new Date(range.setMonth(range.getMonth() - 1)).toLocaleString('en', {month: 'short'}),
    ],
  };
  console.log(chartOptions.value.yaxis.categories);
}, {immediate: true});
watch(financialResponse, (newValue) => {
  series.value=[
    {
      name: 'Omzet',
      data: [financialResponse.value.financialData[0]?.totalRevenue??0, financialResponse.value.financialData[1]?.totalRevenue??0, financialResponse.value.financialData[2]?.totalRevenue??0]
    },
    {
      name: 'Kosten',
      data: [financialResponse.value.financialData[0]?.reportExpenses??0, financialResponse.value.financialData[1]?.reportExpenses??0, financialResponse.value.financialData[2]?.reportExpenses??0]
    },
    {
      name: 'Winst/Verlies',
      data: [financialResponse.value.financialData[0]?.profitReport??0, financialResponse.value.financialData[1]?.profitReport??0, financialResponse.value.financialData[2]?.profitReport??0]
    }
    ]
}, {immediate: true});

const ApexChartsComponent = ref(null);

// Dynamically import VueApexCharts on client-side
onMounted(() => {
  import('vue3-apexcharts').then((module) => {
    ApexChartsComponent.value = module.default;
  });
});

</script>
<style scoped>
.simple-pie-chart {
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
